import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

const ResizeHandle = ({ direction = 'horizontal', onResizeStart, sx = {} }) => {
  const isHorizontal = direction === 'horizontal';

  const handleMouseDown = (e) => {
    e.preventDefault();
    onResizeStart(e.clientX, e.clientY);
  };

  return (
    <Box
      role="separator"
      aria-orientation={isHorizontal ? 'vertical' : 'horizontal'}
      onMouseDown={handleMouseDown}
      sx={{
        flexShrink: 0,
        position: 'relative',
        zIndex: 2,
        touchAction: 'none',
        ...(isHorizontal
          ? {
              width: 8,
              cursor: 'col-resize',
              alignSelf: 'stretch',
            }
          : {
              height: 8,
              width: '100%',
              cursor: 'row-resize',
            }),
        bgcolor: 'transparent',
        transition: 'background-color 0.15s',
        '&:hover, &:active': {
          bgcolor: alpha('#137274', 0.18),
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          borderRadius: 1,
          bgcolor: alpha('#137274', 0.35),
          ...(isHorizontal
            ? {
                top: '18%',
                bottom: '18%',
                left: '50%',
                width: 2,
                transform: 'translateX(-50%)',
              }
            : {
                left: '18%',
                right: '18%',
                top: '50%',
                height: 2,
                transform: 'translateY(-50%)',
              }),
        },
        ...sx,
      }}
    />
  );
};

export default ResizeHandle;
